import type { WorkspaceDateRangeDefault } from './types'

import type { CompareModeId, DatePresetId } from '@/shared/ui'

export interface DateRangeRuntime {
  getWorkspaceDefault: () => unknown
}

let runtime: DateRangeRuntime = { getWorkspaceDefault: () => null }

const presets: readonly DatePresetId[] = [
  'Yesterday',
  'This Week',
  'Last Week',
  'This Month',
  'Last Month',
  'This Year',
  'Last Year',
  'Last 7 Days',
  'Last 14 Days',
  'Last 28 Days',
  'Last 30 Days',
  'Last 60 Days',
  'Last 90 Days',
  'Maximum',
  'Custom',
]
const compareModes: readonly CompareModeId[] = [
  'Previous Period',
  'Previous Week',
  'Previous Month',
  'Previous Year',
  'Custom',
]

export function configureDateRange(next: DateRangeRuntime): void {
  runtime = next
}

export function getWorkspaceDateRangeDefault(): WorkspaceDateRangeDefault {
  const raw = runtime.getWorkspaceDefault()
  const value = typeof raw === 'object' && raw !== null ? (raw as Record<string, unknown>) : {}
  const activePreset = presets.find((entry) => entry === value.activePreset)
  const compareType = compareModes.find((entry) => entry === value.compareType)
  return {
    ...(activePreset ? { activePreset } : {}),
    ...(typeof value.compareEnabled === 'boolean' ? { compareEnabled: value.compareEnabled } : {}),
    ...(compareType ? { compareType } : {}),
  }
}
